<script>
  import { External, M } from '../external';
  import { createEventDispatcher } from 'svelte';

  export let plans = [], currentPlan, canCancelPlanSelect = false;
  let dispatch = createEventDispatcher();

  let onPlanSelected = (plan) => {
    dispatch('select', {
      plan: plan
    });
  };

  let onCanceled = () => {
    dispatch('cancel');
  };

</script>
<div class="flex flex-col col20 f-left mt-35">
  <!--<h5 class="light-gray-text col20 f-left t-center">PRICING PLANS</h5>-->
  <h1 class="members-title f-left t-center" style="margin-bottom: 0px; font-size: 36px; color: #444;"><b>{M.SELECT_PLAN}</b></h1>

  <div class="text-wrapper mb-35">
    <span>{M.SELECT_PLAN_MESSAGE}</span>
  </div>

  {#if canCancelPlanSelect}
    <a on:click={onCanceled} class="middle-button gray discard-billing flex-none mb-35">
      <p class="white">&larr;</p>
      {M.GO_BACK}
    </a>
  {/if}
  <div class="tables-wrapper">
    {#each plans as plan}
      <div class="pricetable-wrapper transition-all" data-plan-id={plan.id}>

        {#if currentPlan.status === 'ACTIVE' && currentPlan.plan.id === plan.id}
          <span class="current-plan-badge">{M.YOUR_CURRENT_PLAN}</span>
        {/if}

        <header class="transition-all2">
          <h4>{plan.name}</h4>
        </header>
        <div class="subscription-price transition-all2">
          <h1 class="transition-all2">
            {External.Tools.currencyToStrWithSymbol(plan.yearlyPrice / 12, currentPlan.currency, External.platformCountry)}
            <span>/{M.MONTH}</span>
          </h1>
          <span>
            {#if External.userLocale === 'de'}
              bei jährl. Zahlung oder {External.Tools.currencyToStrWithSymbol(plan.monthlyPrice, currentPlan.currency, External.platformCountry)} monatlich
            {:else}
              {M.OR} {External.Tools.currencyToStrWithSymbol(plan.monthlyPrice, currentPlan.currency, External.platformCountry)} {M.MONTH_TO_MONTH}
            {/if}
          </span>
        </div>
        <div class="features-wrapper">
          <a on:click={() => onPlanSelected(plan)} class="middle-button blue transition-all">{M.SELECT}</a>
          <div class="features">
            {#if plan.markup}
              {@html plan.markup}
            {:else}
              {#if plan.websites > 0}
                <p class="ql-align-center"><span class="bolder">{plan.websites >= 999 ? M.UNLIMITED : plan.websites}</span>
                  {plan.websites == 1 ? M.WEBSITE : M.WEBSITES}
                </p>
              {/if}
              {#if plan.pages > 0}
                <p class="ql-align-center"><span class="bolder">{plan.pages >= 999 ? M.UNLIMITED : External.format(M.UP_TO, 'x', plan.pages)}</span> {M.PAGES}</p>
              {/if}
              {#if plan.funnels > 0}
                <p class="ql-align-center"><span class="bolder">{plan.funnels >= 999 ? M.UNLIMITED : plan.funnels}</span>
                  {plan.funnels == 1 ? M.FUNNEL : M.FUNNELS}
                </p>
              {/if}
              {#if !External.Website.communityFeaturesDisabled &&  plan.circles > 0}
                <p class="ql-align-center"><span class="bolder">{plan.circles >= 999 ? M.UNLIMITED : plan.circles}</span>
                  {plan.circles == 1 ? M.COMMUNITY : M.COMMUNITIES}
                </p>
              {/if}
              {#if !External.Website.communityFeaturesDisabled && plan.circleMembers > 0}
                <p class="ql-align-center"><span class="bolder">{plan.circleMembers >= 999 ? M.UNLIMITED : plan.circleMembers}</span>
                  {plan.circleMembers == 1 ? M.COMMUNITY_MEMBER : M.COMMUNITY_MEMBERS}
                </p>
              {/if}
              {#if !External.Website.videoFeaturesDisabled && plan.videos > 0}
                <p class="ql-align-center"><span class="bolder">{plan.videos >= 999 ? M.UNLIMITED : plan.videos}</span>
                  {plan.videos == 1 ? M.VIDEO : M.VIDEOS}
                </p>
              {/if}
              {#if plan.storage > 0}
                <p class="ql-align-center"><span class="bolder">{plan.storage >= 999 ? M.UNLIMITED : External.format(M.UP_TO, 'x', plan.storage + 'GB')}</span>
                  {M.STORAGE}
                </p>
              {/if}

              {#if plan.bandwidth > 0}
                <p class="ql-align-center"><span class="bolder">{plan.bandwidth >= 999 ? M.UNLIMITED : External.format(M.UP_TO, 'x', plan.bandwidth + 'GB')}</span>
                  {M.BANDWIDTH}
                </p>
              {/if}

              {#if plan.contributors > 0}
                <p class="ql-align-center"><span class="bolder">{plan.contributors >= 999 ? M.UNLIMITED : plan.contributors}</span>
                  {M.ADMINS}
                </p>
              {/if}
              <p class="ql-align-center">{M.FREE_DOMAIN_HOSTING}</p>
              <p class="ql-align-center">{M.ANALYTICS_TRACKING}</p>
              <p class="ql-align-center plan-support-label">{plan.basePlan.startsWith('PERSONAL') ? M.EXCELLENT_SUPPORT_INCLUDED : M.PRIORITY_SUPPORT_INCLUDED}</p>
              {#if plan.storeProducts > 0}
                <p class="ql-align-center"><span class="bolder">{plan.storeProducts >= 999 ? M.UNLIMITED : plan.storeProducts}</span>
                  {M.STORE_PRODUCTS}
                </p>
              {/if}
              <p class="bolder ql-align-center">{M.ZERO_PROCESS_FEES}</p>
            {/if}
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>
